import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError, finalize, of, tap } from 'rxjs';
import { CustomResponse } from 'src/app/model/dto/CustomResponse';
import { SpinnerServiceService } from '../../../shared/serviceSpinner/spinner-service.service';
import { MentoratService } from '../../services/mentorat.service';

@Component({
  selector: 'app-confirmation-mentorat',
  templateUrl: './confirmation-mentorat.component.html',
  styleUrls: ['./confirmation-mentorat.component.css']
})
export class ConfirmationMentoratComponent {

  iuf!: string;
  cohorte!: string;
  status!: string;
  confirmed: boolean = false;
  noConfirmed: boolean = false;
  isOldInFODE: boolean = false;
  isNewInFODE: boolean = false;
  serverError: boolean = false;
  currentpassword: any;
  constructor(
    private route: ActivatedRoute,
    private spinnerService: SpinnerServiceService,
    private mentoratService: MentoratService
  ) {
    this.iuf = this.route.snapshot.params['iuf'];
    this.status = this.route.snapshot.params['status'];
    // console.log('les infos : ', this.iuf, this.cohorte, this.status);
  }
  ngOnInit(): void {
    this.checkConfirmation(this.iuf);
  }
  checkConfirmation(iuf: string) {
    this.spinnerService.showSpinner();

    this.mentoratService.mentoratConfirm(iuf).pipe(
      tap((response: CustomResponse) => {
        console.log('Confirmation Réussie :', response);
        const data: any = response;
        const useremail = data.object.beneficiary.email;
        if (useremail && useremail.includes('@')) {
          const username = useremail.split('@')[0];
          this.currentpassword = username + '123';
        } else {
          this.currentpassword = data + '123';
        }
        this.handleSuccessLogic();
      }),
      catchError((error) => {

        const statusCode = error.error?.httpStatusCode || error.status;
        console.error('Code Erreur détectée :', statusCode);
        if (statusCode === 409 || statusCode === 401) {
          this.confirmed = true;
          this.handleSuccessLogic();
        } else {
          this.serverError = true;
        }

        this.spinnerService.hideSpinner();

        return of({
          success: false,
          data: null,
          message: 'Erreur gérée',
        } as CustomResponse);
      }),
      finalize(() => this.spinnerService.hideSpinner())
    ).subscribe();
  }

  private handleSuccessLogic() {
    this.noConfirmed = true;
    if (this.status === 'old') {
      this.isOldInFODE = true;
    } else if (this.status === 'new') {
      this.isNewInFODE = true;
    }
  }



}
